import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getCookie } from '../helper/_cookieHelper';

const Layout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = getCookie('token');
        if (!token) {
            navigate('/login', { replace: true });
        }
    }, []);

    return (
            <Outlet />
    );
};

export default Layout;
